import { Modal, Notification } from "@scuf/common";
import { DataTable } from "@scuf/datatable";
import { useEffect, useState, useRef } from "react";
import { PFDFetching } from "../../class/fetchPfdTostacion";
import { GlobalCorrientesPDF } from "../../class/globalCorrientesPFD";
import { getValoresPeriodo } from "../../services/services";
import "./SvgPfdTostacion.css";

export default function SvgComponent(props) {
  const notificationElement = useRef(null);

  const corrienteValue = new PFDFetching()
    .setIdSeccion(7)
    .setUltimo(1)
    .setOrden(0);

  /* color de fonde de la aplicacion 
    background-color: #202020  */
  const [openModal, setOpenModal] = useState(false);
  const [corriente, setCorriente] = useState(0);
  const [dataTable, setDataTable] = useState();
  const [loadingDataTable, setLoadingDataTable] = useState(true);
  const [modalTitle, setModalTitle] = useState(
    "Propiedades del flujo alimentación Tostador"
  );
  const getValueClass = new GlobalCorrientesPDF(props.data);
  /**
   * Función que muestra o cierra el modal de información
   */
  function showModal(corriente) {
    if (openModal === false) {
      setCorriente(corriente);
      setOpenModal(true);
    } else if (openModal === true) {
      setCorriente(0);
      setOpenModal(false);
    }
  }

  /**
   * Funcion que recibe el estado, si este es 0 se mostrara un mensaje diciendo
   * que la planta no esta operativa
   * @param {*} estado - number
   */
  function showNotification(data) {
    const arrData = [];
    arrData.push(data);
    const estado = arrData.find((x) => x.Estado === 0);

    if (estado === undefined) {
      notificationElement.current.style.display = "none";
    } else if (estado === 1) {
      notificationElement.current.style.display = "none";
    } else if (estado === 0) {
      notificationElement.current.style.display = "block";
    }
  }

  /**
   * Metodo que retorna un componente modal para mostrar información
   * @returns JSX.Element
   */
  function ModalPFDTostacion() {
    return (
      <>
        <Modal
          size="small"
          closeIcon={true}
          onClose={showModal}
          open={openModal}
        >
          <Modal.Header>
            <h4 id="title-modal"> {modalTitle}</h4>
            <h6 id="subtitle-modal">
              {modalTitle === "Propiedades del flujo alimentación Tostador"
                ? `Corriente:  ${corriente}`
                : ""}
            </h6>
          </Modal.Header>
          <Modal.Content scrolling={false}>
            <DataTable
              data={dataTable}
              reorderableColumns={true}
              resizableColumns={true}
              loading={loadingDataTable}              
            >
              <DataTable.Column
                initialWidth={350}
                field="Detalle"
                header="Detalle"
                sortable={true}
              />
              <DataTable.Column
                initialWidth={150}
                field="Valor"
                header="Valor"
                sortable={true}
                align={"center"}
                
              />
              <DataTable.Column
                initialWidth={90}
                field="UOM"
                header="UOM"
                sortable={true}
              />
            </DataTable>
          </Modal.Content>
        </Modal>
      </>
    );
  }

  //Efecto para cuando carga la pagina de manera inicial
  useEffect(() => {
    showNotification(getValueClass);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (corriente === 0) {
      return;
    }

    async function fetchData() {
      // Si la corriente es 0 no hacemos peticiones
      if (corriente !== 0) {
        setLoadingDataTable(true);
        setDataTable(null);

        if (corriente === 18) {
          setModalTitle("Infiltración Teórica");
        } else if (corriente === 19) {
          setModalTitle("Impurezas a PLG/ETP");
        } else if (corriente === 20) {
          setModalTitle("Perfil Resumen Planta Ácido");
        } else if (corriente === 21) {
          setModalTitle("Desempeño Modelo USD");
        } else {
          setModalTitle("Propiedades del flujo alimentación Tostador");
        }

        corrienteValue.setSecuencia(corriente);
        let { data } = await getValoresPeriodo(corrienteValue);
        showNotification(data);
        // En el campo valor cuando sea null, hacemos que ponga un string null
        // esto es raro pero no se pintan valores null cuando es primitivo
        data = data.map((obj) => {
          return {
            ...obj,
            Valor: obj.Valor === null || obj.Estado === 0 ? "null" : obj.Valor.toFixed(2),
          };
        });

        setTimeout(() => {
          setLoadingDataTable(false);
          // Guardamos la tabla
          setDataTable(data);
        }, 1500);
      }
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [corriente]);

  return (
    <>
      <div ref={notificationElement}>
        <Notification
          hasIcon={true}
          title={"La planta no se encuentra operando "}
          severity="important"
        >
          {"Fecha de consulta: " + new Date().toLocaleString()}
        </Notification>
      </div>

      <ModalPFDTostacion />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 3456 1376"
        {...props}
      >
        <g
          id="d83667d8-db07-4c33-00ae-7274854f1601_svg"
          className="tl-centered-g"
          transform="translate(888.00, 1040.00) rotate(0.00, 32.00, 0.50)"
        >
          <defs>
            <mask id="d83667d8-db07-4c33-00ae-7274854f1601_clip">
              <rect x={-100} y={-100} width={264} height={201} fill="white" />
              <rect
                x={32}
                y={0}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L64,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 50.14,-7.999999999999999 L 64,0 50.14,7.999999999999999"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <image
          width={72}
          height={216}
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref="data:image/png;base64,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"
          transform="translate(1032.00, 576.00) rotate(0.00, 36.00, 108.00)"
        />
        <image
          width={321}
          height={277}
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUEAAAEVCAYAAAB+EVfQAAAACXBIWXMAABcSAAAXEgFnn9JSAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAL/JJREFUeNrsfW1wXNd53iVAAiCJbxCg+Al+SYpIaUDLlGsmagDWnnEzrodypnHcaWZEe/KjqX+E7L92OiO6+ZNOf5DJVJn+cCf0pDNt7JmamXy4zjg2WFmiVMkSWIWyG4rikqAofgsAKRIASbHnOTjv4uDy7u69u/fr3H2emcO7XCx2F/fe85zn/TzLHj586BEE4Rba29q2qANGrxq7zdNj5ij/nzBjSo1xNUpz8/Mlnr2lWEYSJAjnCK6nwY84YYhRSBLkOEESJAgiDYLbbcgtiOhGQ79Pe7s3ODioH2/ctEkfh9T/8Xx7R4c+zkxPe5MXL+rjzMyMd1E9roHzIERRjYYcx0mCBEHkhuC6e3q87u7uur/j3Nycd+3qVe/qtWuaGPEYR4wqmLZVo6UeC2FakwQJIhzBiTmaW4JrFBcnJ71pQ4hCjtcUWYYwrUs+cnTKtCYJEiS4RYILUnIjYd8HBIahiW5oSD+3aeNGfcT/8byLABHOzc5GNa1PeVZAJs+mNUmQIME1McE1Am1GK1K0TWtNmMrkroLztmoUM1sR5BRJkCCikVtQ5LQughuUgAIJLhHTGo+1LzKaaQ3VOJWGaU0SJFwhOFvJDUclOK3kenr04yGfT45I17Quq8doprWtHmM1rUmCBAmOyI1pDb+jRLAjmNZaNdZrWpMEiTgJzjZHg0zV0AS30WeOkuCaE0KItmkdIaVHTOuj1YiRJEjEQXCRqhj8BAcl14OgQ0dHOX2EIKKY1u+8/XY11bivmvm8nKeSIMERrilDEJ+YzFUCLqIIp2gONzfBpVKmRYIjkjSDhfCqmMHnvcWqFvENlsJ8FkmQBJfrKgaiuLDzDEF68PcBIaLFZ9X4mbcYFGkoz5AkmF+CE3OUBEcUiuhC5gxWw744U2ToE8yW4FjFQJDoAgDfsizauKfhcjn52mve2bNnRRjEBpIgCY4gasKuHxZ/XYhUlUCsWLFCWycrV67U97IEz/D4T15+Wb/mt772tUd+Dz8nCWZLbrGVaZHgiKITXW9vr9fZ2Vm+n+X+zmOOJ0nQYxUDQaKrh+hwr3cbBSf3uYt+5sKTIAmOaDaIT86uzw1RgvYIVq1a5a1evVrf23Kv45jVvW6R626S4CLB2eZoLGVaJDiimYgOC3tLS4u3ddu2RaLLKO9TAimVlGTP4vO9TUGCrGIgmhliqjZKdK2trV5/f7/X1dXlDa1dW1ZzefQ9w0yvRoKFModJcAQRXBWhU0xqJwsHmq2PrVunj5JSUuD7P99KMMkqBhIc0YxEBzUHJQeyW/vYY/re77ECEs0Cyy01Euf7RiJBlmkRxKOQZOFGiA4E19bWpudFpyK8Hdu3+yc+kbQ5TIIjiNpE10hVBO79DmXFrFHzAcpus5ofnBM5IcGBgYGj6vD7YS5ipSRfXkyi2Ylu+fLlWtH19fV5qzs7veHNm3XCMNVcfAD34JogrhDXvseaBO988smeoB/u3LlTX8AdO3awioEoBCRZuF6iQ6mXLvtSIgAEt3XLFm2+0kedDnCejZsB1mp8JHh3dvZ5U/P6ghk6v+69997TA11btysiBBnyYhOuEF09VRHImYPJiihrX3+/t2ZgwBtShLd+wwYKgSKbw4BpTYNx0KSwCCGOSvfW10+e1CYv0lJAiCBGgnCN6KDkMJA/t0qR3fp167TFwwW+yUnQhrG14Sc8asrOQIZQil9VN1m3KERg+/btZZOZPkEiTthVEVGJDqoN0daenh4diOhVx527dlHNuW4OK1VuzOExI9qSIUEfIaJj6zEzDvjNZrS2wTgxPq5XUhDiLnWzcVUlohJdlKoI5M4hEKFLHBXZYRGGunv6mWd4UguMJBaxyMnSFcxmEON+MZvhQ8SXhUrEzSkF2ASJLirRaTXX26vvHwQhevv6vK1bt/KkEtmRYA2zWVTiP1c3+Gqazc0Bf1VEVKJDxBURVlRBrKN/jgiH2ErnYiubM2bzcQxFiHj8+3A84ybHZKDZXCyii1IVATMVRIdoa59SdfDrbN68mYshERnIS3594WFs7bSSaqAAReg9//zzOoKMSfP+++9rswhEGGQ2Mx/RbaJDWglMVyg5EN6wMl3XrFlDoiOKbQ4HwfgJdYGz3fjg2Wef1UMSVEGKIET8X8zmv/3Rj3T6jeQkcgLFjwa2OSxfD1wjVEbAN8dKIYIkWEEFYqIEqTqt/KwcQyhCTYhq4DEmIwbMZkwuTYhGKRL1E13YqohyfatScWjNNKBMWO57QuQFWHQ9B8xhBEZCJ1LDJ4ixd+9ePXknYTIblYj/w2Sm2Rw/0aHkC5vh4Hw2Y1smwlESXLQ6euJ6zyRIcB/+2VSHcsMfiGAJBgAy1L5EpQwx6ZvNbA6qighDdAhGYcVcqRRdM/efI4jUSdAkUnfrHahiiPpGNZs3GWJ0nejCVEWA6KDk0JIJZmvWm+AQBEnQMoWl5X2ciGI22yoxD8qnXqJDRQTaMoHsBtasIdERhOECzCmILlO8kT8S3JGwGgsym0EwOIJYJCcRZjNOGGpGNyWcgFtvVYROFO7s9PoHBjThkeiIZsW0EQW1hEvcwiY2EjSpMcNixqYJMZvHxsY08UAlvnf6dDkfESazkGcjZnO9RId0Epit0o6pCTbCIYjIEMtIGja7aA4vRIXN3ghZSmUMyUkUP6IEV2qZzY0QHcxWBCJIdASRHCwluCVvJDiGf/JkxuFkhTWbwwAkZ7dLJ9ERRAZCRylFzNs8kuB+/LMjx9HZamZzEEbV6+CjY1UEQRQXsZBge1ubNoVlIyYnVhOf2Yxx8rXXyl1vAPyMIAiSYGhT2NV2+zCbMYzEJggix7CEViylcy0xfS+tBDclkB+YFoKCH2HauBMEkS56Fkkwlp6CDZNglqkxcQJRZD8QHSYIotiIQwnmIjWmUZwNIEGCIHKNfChBL4epMVERZfNtgiCyhcU1I5mToNlXJPepMWFNYWy4jUEQBM3hSCoQqSYu59FJd2XU76JpgWAyRLdlgiCamwRfcN0U1iRoyG5AkSBBEPmHlM6ZwGz2SnCHw0ER+AKRCgMFSFOYINyAVaqaHQkqBkai4rDrbZ8mjSksexew8zJB0ByOpAI3OpwgDUhqDDYU0iTY0VH+GfMECYIkWA2RNlTKI+w9dXt6Ht23hRUjBJFTc3ix5+BYJiRoUmNG8XiTw6awRIXhC7QVIEEQ+Uacbqt6laBmX9dTYyQ/0FaBHfQJEgTN4bCmcFFSY/qt1BgqQoJwCg2XzjWkBIuQGoOtK4P8gfIagiDyB6tjVcPttCKTYNFSY3p6Ky8ktfYVIQgiPkg2RtppavUowUJ1jZHUGIFdNkcQRIokaLIxhlLes6duEnS9a0yl1BhWjRBE/tG9OG/TNYdNaoxuX+Ny1xhJjcE2mbUCITSJCSKHJLiYldKTthLUKhCpMS6Xl0lqTG9v7cDStatXeccRRIERlQTH8I/LVSJaCQakxhAEQRIMg6+6bgqHSY2p9DxBEPmBdJJpb2sbS4UETWpMN8zgwZSjN3EiTGoMQRD5R1wuuShKsBCpMRIUCav2rjJhmiBoDtsk6HqpnGyw7s8PrARGhwki90pwS+IkWJTUGEmQbmtrq5oaw1xBgsg/rHZayZOgV5DUGNk4ac2aNVVf18qqEYKgORxEgjt37XLbFDZKsDtC9JfmMEGQBIF9+MflBqpIi5HaxCi7yjFZmiDyCatqpKHSuZokaHJwuvGBLqfGRKkSoU+QIPKPnkUSbCjfLYwSXIgKO76hkqTG9IWICrOTDEHQHLYBJeh0VBiImhpDEARJUHZ316kxLucHSkBkxYoVkdvnc8c5gmhuJTgmpnARUmPC+jTtzZZIggSRT0wvzs2pJEnQ+b2FbSUYNjWGmy0RRP5hCZSJJEmwaVNjCIJocnO4aKkxbI9FEMWClcNbSkoJFio1JmoDVbt0Tt6DIIjkzduw7iirmisxEoQSdD41ptKGSrXQyYRpgsiEBAfzsNucnRqz3fENlbBaIPmZVSAEUSyIwPESCowUooHq+yZBmv5Agigu5ubnE0mR0aaw6w1UxZdn9R2rC9PMFSSIXJrOiZnDCvvxj8v+QJyka6Y1fj1K0M4pZMI0QeRsfk9Py8MTsZNge1ubNoWRGmO1qnEOk9YG62yIQBBEFCWoTeGiVIm4nONIEEQwrA3Qphp9ryAS1Epwk+v5gSZy1MeuMQRROFg5ghONvleLzxTeog7DrivBOFJjbD8iu0sTRPOYw4VKjens6op71SEIIidCJxEl6BUsNeaxxx7j3UIQxUbsPsGmT40hCCL/iNM6K5Ng0VJjOjo6GkqNsX2JNIcJIl8QoTM3Pz8epxIsVAPVRnsH2gR6bTEcTxBEwWCT4Jg2hR0PikhqTKOlcgRB5BNWBdd0bCSoTGFsXjyMfURcDopAscF0bW1tZdcYgigqCS6WzE3E8X4ttgp0vYGqdJGOiwBd3lyKIIhoJFgof2B/TFUiHVaHW/oFCSIfmFzsI1iKhQSVKdyrjqP4j8sbKsEMFqJam0B+4NzsLO8+gsgX4iFBMYXhRzt9+rSz6SDvWxuss2sMQRQXcXPUcjGFHzx44L1+8qT39ttve7t27fKeffZZp/IFpUokzgTpVpIpQeQOVi3/eFwkuNue9POKZd9RRIixc+dOb++v/qoTZHjW1AuvW7cutvdEgOXmjRu86wgiYZR3mssgGLncmMNg1JHNmzfriT954YI3PT3tvffee3ogarx3797cps9IasyyZcuWdISOE3DGul5TTRC5JUGT9hKm/6eVJzgVx2cvxyYl7W1tx0GC9+/f1+ZkzzPPeJ988ol36cMPvatKeiIB+fvf/77+gp9RZjLM5TxB/IHoIk0QRHOoRsVdseYJajxQJGibgo8/8YS3Z88eb2hoSJvKUFx/+6Mfef/1O9/JVRClXCq3Zk28Mpk+QYIoPGSWa0aF+vMDu8GDDLcqgrx06ZIeYGKQ4fj4uA6gYGSVWGynxsTpD5SFgCCI/MDK1z0fNwnWtK2hiuAzxLh65Yp34cIFTUCIKGNkFUQRUxhKNUnlZpXqEASREax83VIiJDgbMiF4aO1aPUCG8BnaQRSQIXyGaQURJDWmK6Yu0rX8EARBZEiCCbjgNAnCwdje1hb5A4QMQYIwk5FOYkeUYSYnXYonqTHrYzaFCYLIH6xd5ibies9Y7EcdUVYDUhVmskSUMWAef37v3kQiynZqTBK7yrEzNUHkFlNxvZEdHdaOxqDgSFhIEOUfff7z3qbNm7WfToIoL7/8snfy5MlY5az4A9nthSCaA0n45m0lWFJj+L6VJlP3m5ogyvr167UqRL6hBFHiLMsTf2AaewtfXOxcQRBEViS46JsfT8wcjoMEbTIEEWoyvHJF+w2hNO2yvGc/+9lQWeJ+gFSFmNauXcu7gyCIhkkQjsZRkFSj+3MEwQ6ixFGWJyqwpaUl0Xw+vHcjLgKCIOKDlSdYSoIEp9L4I+IqyxN/4MqVK5NdJVg1QhC5gcQU5ubnYyPBFj8JptU81C7Lg7nsL8uD77BaEEVM4aEUTWFuvUkQxUOLzxxOfaIjorx12zZNhnZE+cT4uPcdRYaIKPsTlUGW8hwINDUpvtjHjCCIlCEuMIVTsVp7efkDo5TlyQbrbW1tiX4nBImQg0gQRK4Qq+vOnyKjAxZZQ4IoN27c8D66dGlJEGX79u1lFRglmRmEZgc47L8Tz0sHHZQO0uwliPwhqXlZJkE4GtsTVlZRgSg1BghL6pSlTA5YtXq1/lmShIZEbJIiQWQPq2RuPHFzGKopT1FRKcuDqfzWW2+Vnz9fKkV+HwECM7KHSIciunazvSb+bjvlBmY5UnrkIrC7NEEUC36mO+GZXME81s22W/sAQ6HJvsBhCS2vcpwgiNoonTsnD7+irNZjcaXJOJsEB58hlGHSYGNVgsgWyAY5/oMfeLdv39bCRlmqz6qnzyki/H/q+MeKDP+kkfdv8f0/1VxBJ6Qyk6UJInFMB+w2B8vrxz/+sfff/uzPNAECvn2EnlTjZUWG82r8RI3dcShB5Arun6XZF0iCNIcJIhlIxsfg0JA+nvvgA++HP/xhec6BHNGSD41X8Nzfv/uuLqgw5LhCjX1qvKOI8Lo6/kc1voNN5AptDqcF2xxmsjRBJAsQ3F/95V96Z86cKT+HtLixffvKXadAiJ/ds0cPmMpvvP6694EizQcPHuDH2G3tP6nxh4oQX1fHf6vI8JWoSpD7aRAEkQnQXUoAsvvSl75UtTs9+g38s698RT/+5S9+4b355pve9esQg16rGr+mxv9WZAi5+F01/n2QOvST4BQvw6OQXMF79+7xZBBEAurPn+6GRiroLBWlYfKvPPWUHni///PGG97fnz7tzd69ix91qvEtDEWIKLn7d4oM/6aqORxnT8EiAKk4OLGffvopTwZBNEB26Bx1ThEe1Nr01JR3586d2OcViPMf//qv6/Gh+ryfvfKKd/nyZfmcETX+WpHhz9XxPysyPLaEBNUT46gaYf+8YPC8EEQ4soP//B/OnNGbr4HwUL318OHDUBaXmMX/99Qpb3RszBsZGan7u2zYsMH77a9/XT8GGSKYYnyHn1XjTxXf/REDIyGw2pTnYdUiCGIR6OwCZffxxx/rOv+7yvysRXaYTxgoakBRhl3gYDdPAVn95O/+znvrzTe9f/obv6EJLQwQLJHvhTmLGMf8/Hyl79UdRIKIivRA9TBReAGtzBUkSHbeRWVaoqkJHgtJ1SI7kJuQXod5HGRhTSvyw2vtPc2FDJE+870//3PvsXXrvC9/+cs6Sqx3mlTq8vTp095t9ftTioR134Aa3wlzuVN9h9uLPQb+IGh26zb79AsSRHOS3WVFQCA7BCtgxtYiFilh7TaqbnVnZyDZgVOk4QkIDKTldzFBGaKvaBAZXv7oI91wOYxoAdG1G4WJ74J8X7sUGHmGpvHKTyhxQgAnb5KngSgY2d24eVMHDC6cP6/JrpbwEXLxm7NBEKJD4QXMUUt5BQHb/ZYgvjRJKoLqHxjwtm3dGthWLyzR+b8PCBXfB8R72yLfikoQv8TNx4NvHnaSIVwBzMYb169755WaAonAR1ar8skmO9ucDSohFaIDX4BcROGFwCHDNROSu9fe1rZFHQ6r8SICKhhDQ0O6R4C01avmpsNni9J8YPqH1iDfiiTIXEH/SaJPkHCA7KC43j97Vkdmb926pdVdGCtH1JQ/SFFJ3YkZW41gTKODJbs14v1FySniO/oIiS10hTmgyBBEiJ/vRw9RjE1mH3MJUgr5RiDeU4bbxo3qLAkBV5zdbKKwCAaIiLyRHSKfV5Qpi6BBGLKzVV0tsouq7vB+ftWIPcbRh7PfqDcAqi5M53pDhi8oMhwzynB00urrWQXTRl0KyYHwptT7TURVgvjFl9gsgCCyA8gNig5kh+PU1FRksqsWkbXVnU101dRduxX0wOg0nxWEoPeo9NoqZAguGjNkCGU4UkvV1WXp8XYLB0nkxE1JnyARJ9mJGSuJxWF8av6IbLUghai728aM1eP27aq+Qb+6ixofsE3gRoOKhgx3o1VWLVUXFwmCVZdET4jF0jkmTBONkJ0ou5s3b2q/XS0EBSlqEZJf3VUzQeG76zaEV0vdxYjbdZLhRBJfZnmQPY7SuQfMEwwE8yeJKGQHMzbsDo5BvrVqQTkQ3KwVqKil7lasWKGbgKxcudLr6urSAYd169en0qHdP43ydM1oDodEt4ls3aFCJrzF+lhsvoW9L0B+KB0LS3ZhI7Ky8PqJrhqx+lUjEoMBuHHQrBT7daeg9pxBJRKE43GEuYJEs0MX/9+9q8nuypUrmvhAdmE6n/hVXRhT01Z3UJTVto2NkrycFVxoOlKJBJkrGOA7EX8LUWxlJ2QHU7ZWyRhgBynCRGTrVXeVmg7kGS64j6qawzpXkEqwfBMC6EZBFIPsoPJQSoUgRVSyCxORtdUQiC5kCVmg+fz0M8/w4qVMguNqjHLDJcJloMQRu5iB5M6bdk9hlEmUsrEgdVetQUAldYf0GLwWlRGSFLx12zbtw4sL97iAR1eCxCI6TJtvttjPL9khOHH2/ff1MWyyvwQp7CTgMGWSUdSdkGq1LitB+/rEXamUphUjKXYdwe3xc6WuKl3tklxowphCxv/CFvv5ITtst3h3YQ+J0GQX1adml5CFUXf1kqrAvr/ER+hi2aYsCPY5tkpxcxVzqEqCzBUksiY7mINIKg6bpB61bMxGPQ0CoO5Q2B/lcyqZ0rbJavsai9LU13KvXXbGHGZi8KMTDJOD7bTigTQDQJBCesUhIhtKmYds5FlL3YXtQtLb1+fdv3dPq88NGzd6LS0t2ncHskKLp0Yhn4+/w4txf+us57DUO0fZNS4vJDhBczh49SfSJTu/Py1qLlwUdec3Y0GyUKJ4j42K+BBJBgmCAF2BXcObCQkad0VHjtN5Amc1ujGgdI6oMLGUmbaRp6Eq2aHNE6KxUckuakTWVndpNghwHTMp+RtdSCmrdofpDZcm3nlH+zzQF6zZlZCUzmGvg127djXteZA2TyA7HNH6PCzZCQHZQYqowYMoDQKitH+qqWocTxn7NGC3NVo31UkQ/bsOqZus+8yZM17ruXPe2qEhTYjNXnfYLL5SaQYwefGiPkLpYYRFo1UOUdTdsmXLvFWrVunXwfTa8fjjTqq7JHP5RJXZ3Z6JKiSoTOLDyiQGER5Q4+CD+/eH0S0WA6oQZNhsJoSsmlFUj4tkB2WH0rEoZFdvRFYWlSglZCA7iRYPDg5qYsY2jEg0RrMAqD9X780kzUfxhSYdbQ4hEkquKEHPdGoFER5VhPiCIcT9sgkKbja04WkWU1kmtqsJ036yu2l2GwuLesvGbMTRIAAECbLDYyjAJGHn6j10PEc0LQsm62BMrCToI8Tj6nDc7Ah1UI1vqJu3KU3lvCdM2/Wx0ggACj4s4uhO0mj7p7w1CMAiP2/l8LGRRhOYw1XIEFL2oNkRCurwsG0q4wZBo8Y4cqfyqgRhLuaN7KDyEJGFaRhWqTYakW1E3TWiJvOAOAsJmI/rGAn6TOVjGGYjFKjD/bLvJ0yn9Rs26B2mimIqZ/V3+MkOj+Gzi2KW11s2FqTuwpaQtba2el3d3d7Uxx9rckUnlKLcC3GafEmajyTYBEnQR4jj6jDuN5WRaHrhwgVvoL9f+w6LZCqDmOLOgg8iO7RAj+Isr6eRZ6WJGaVBwHJFePj+8A97Dx9qf2NnZ6dOMgYJgvxcJ8CHASkmeVebQrBQ3rMZbKNrL5J5LcON9a4MMJURVR6RDZSLYCqLPwgE1UjpnF0fi8dRyS6ouqGexNeo6q5Sjt8Fsy8s/l/UPavT9gW7FmCIQIgTefpeiSzNAabyATVeLJKpPIVSqhAk6Cc7BClQehWF7BqNyAqilpBF7ZZMxEC0KavNjOBOA4WYTeXDhgwPiamMASIEIboywSTHCsrn6aefrkh2IJwwWyra7xt1a8WK5zxig4BG2z8VFVn40+6a/EcsPjMFiEBLx27Zt7spSdBnKoMIkYQNMoTvcImpDEIcWrs2t1Iek0KUE3YY+/73vheZ7IR0Go3I1qPu4m7/VHRkYY4mSbxp5wmC+MpdZMy+3XlEJsu9IsSKpjIUFogQkzRtNSIKylZPldI98NzFixdrkl2jEdl61R3Q19/v3VLKFDf/JrO3bJztnyqqGcsnKP7BOKsU7EnG8q/oqkwWTyCJRfC+3VDVATWbqc1jmcoHjTL8piKXTZPGyZ6EqWwn8eIxTA55rhpQmVApOtho2ViQumukQQAS2PE7G9S5O2P+zjQxbxYNfJ9Z63ESk8y+bkkQbtFBt0dO9hgxgRQxlX+pjk/i+XpNZSE1W9nBRKyV5S9+OVFvYqaKOYQk6V/+4hflSf34E080NLmL1P5JCMieVGmQkagbfFYShEuQBLMAnKZPoguI7k2nSFBM5Q/OnXtEMdmEBwIJs50hyAOTRqs2H+GFXTWXm99PQt3FleuXKglmRECiztP43DDbctar/MvKOYX0Itz/kyldH+f3Hc4IJTVGMamgtLDtIMrx0NXXVknaZK7yJkJqdmpJGlHPKCVk8j1thdfDfZ5zi6STpZNQzjMZb9aU1MLRDCS4RHGh2gTj7Z///JHdxfDz/v5+rRjhi0PaShqq6b4xr8M2CMB3k1UexH792jUdVcZjEh+R+ESn768icrtZQpBJ22Za/g9v2VJe2XAUXyH2fghLgI1GFfH7aOeEXEcx2WU17zEpKI8rk76ltVU/b+cU4ju7tE9Fs6JSoAXXlzW5BVogcvidam7y1NXVpZVUPdJbetEBv/b88w19UX+rqSBzG5FaICuf3pzjLeGzRLVAS1I5hEUg10o++fvNUDscE+pu2xy1thMrfb3khI4orpmxMw5v5t0ssBfyOEkjzXpue4GYDHjepMbRHK65Cte4aEFKMarjeragKmk2IF3FJuyk/UPzKXbeLrJZGqfanKVF4A4JyipRjxkXVQkWtTvwXMb5ckm3obcVrQvRR4IkmNqqH5UEWXLltiJLM+LJdvqNoSPm3pvNQILTQSRVyTywb9Aovo+i9r1z3XRrNgT5aotwHu15medk/7yS4ES96iKK7yNNJdisqvMBU0kyVbZBjRKmGSBz1xyOg2wqqcsimovNphCD6pfjVmhFIlgmUOebBEt+OV0J/kTWWmTj/3mStZrVvkszrMZp+4GSCgiRLEiCmZFgGPhv+KjKLkklWEkFpZWukrXPM00/UBGIqig+6tvmvs9zMMQZc7gef1KE35lO0xzOAs2UG1YERZ3k9bIJNknXhN193ZXdJfO6fFYtnQtjZob8jNGiRYiz9j0WdVFx/T5JimDtJiK1diokCUbDVAoTbRwkWLRJm3WqShokLH7cNIlJTDz4oJu1g7Wf7KLkTuY5MJjrq1hH0OKKGmtxcUKSwHk1hnFBmS7gjvqUAEia5paYeJ3WlgGdBb5n7K7niJJXaVZ83lhVGOOo+Gpva3voX6QssXGCJBjmAiycyCWlcyFX39lak9K6GFCbJZAgyLYZSDApsipqonRa5B6UKZDmwiLd2f39MYO+qpCdRXpTaZvgTaUEg05ojdX3sii7SrupWasZLmKvmMRJ7r5GU9n984XO5olPRmuBj+Na2bvyBeHOnTvexDvvVHMvnfCpvFIRr3OeSRCrTk9EU3XWR3S1UPKpw8RX+8wuNHPdmtZN0VHBbXDv3j09DE75CG+iWc5TnmeGjt5GNAsuRyS1BRJU8r/ooM+z+PD78W7Vvq/PqvG7cfb3a29r63VtES6aPKjpE1xy0wT4HuO+KYGsoohsAe+mcgv7WtuPh2NYC8j6nIsJNDjdHWTG53kRzjMJQqWNhon0ziyamsfVeDGieasjxBEiyuEZOeO+fmwVFh/uppCOY18vf1dmO2iBx1UWbvHjgdxgB/93e0H2fc44r2z+STAqpmwVFjKFAp8zrG8SBgxiJ940a6STVL6fZtS89bYivVd/9rNKPz5lEd6E34+nrJyx8nxgZ2l3zeEgiV9D4WAlHIUKCyJBK/dwyloNR4tSYlYrIpgVESXhE/J/lovR71oJ31bn7PM+wqOKawISrFg6V2PFnyrfXAGTQVZEa9Us+UzqxJGkOrqfQd1mmsRnk3yS5n4S/tw6/XhQe2PV8vHyihlHunHnmQRDXfSAiQZy2x9B2ZV8CjEZcyqg9X9R0laEjPykniTJdyRM8nFUhUTw41VT7lNxEGDUTcioBHMEkBNu/ErqCf+/eePGI+QZViUkHSEW3Jufd85Ui4osa2mzPq92Xa2QXxVlZ1ddIKXkpwmR+m6/ai5yTXnhSNCQ04wip25slt7b1xd2omkzN2IbrsQixIJ5Q4JEcZQvJjbuzSqJ8DX9eHbwIgH0imsk60wB6/Nzl4SddyU4qsYJdQK779y9G8m8vR3touPCJBohvpfiXrxEctcPqkpUjY9Y7LpaIb2pJjxVZfVZwbrK3TnJNQkieKFWyhH18PjDTz8dCfk7JZi3EZVgVD8iUVCIKfvxzZuBSt4XcHpDjT80hFdq9LPte9bh/oVl9TnHBgqxEWHJmAy/VGNtFPPWX3dcxS+hJXrc0Sx7ox6f3zJtE6Rpe+DVOj8h/XiV8L/U/Xk8ietlLcjjcbw3N6l3mAQNEU4pIvwv6uFLEUzi4Up5ZN6jPc30Kp5UhDirKLCtLNLqgZfXKhV/XW0IP95FNb5VlIk+yz223SbBapO7CgmOhg10GLO7EFn1We/zm4d9hiPk41X046n74aA+OrJZUB5x2zRwyLv14SQJhlAbpTreFqkLI0lGiNM8N/gbxK9V1Ilc6T544/XXK/2KXVdby49X9m0VDWktVGKC570Dd1EdRPX4+DAhRjCxipLLJwmySScW277PpKsErl+7Vv6sGoth1braHKEcTb1rMiCSVk5soOAuCfZW+oHl35EbfUrMoojEuX+OvpP6bybf5G20jrmaH89PFPa1VoS3zLX72s7li1E5aYLNYv9fl+aRSyRY7lNWSW1YeVkTIc3mR9Qj20/FhyglbhH8eHDctldRNyeaeUJnZdIfOnQIUfLeL37xix1nP/igrNgBlIyiC89zn/uct3HjxhfUa8fU0wePHDmSC3VeSHPYRJPLkytkdBbmcNQk63pMEMKruz8ejge88FkCsYD5o6EJd/SJJ5/0MADkVraZeWhhpJZlRxKMD7qllu3jCzCbbeKckCTrCMRZNwEARWx5H1SoDwc5NiqKWlcb5Mdrf3RSFQZFyOVraWkpqz+bAPH8smXL9PN5a+ZQ+MzZCqVwU1UmYWzBkVo+yaQd4FnUK8tEts8fUiXOnDnjf2nD/fGK1hklqVw++z7EPZdkdLi1tbVMhHJ9QH4ClB+SBNMDJtXojZs3vaG1YQtN4o0QZ925I+l6ZfHj2ZO3Qht6zLpXvZjraoMIN0aMVVLrlpItuTARbOWdRgRfYJNfnuE8CVaZANqUQrka9lZ9+plnwrxd4hFil03gMH68Cm3oX1WkN+bi3xzkFrGUVMkjnIeTJBgmeIGazva2tq+qh99FF5q33norjGJIPEKctAks56bRtIiI/fEe88LXdcdueqcJnNeZFD5n7tFtIAiSYOBKHIYI0Y7rmPqdkRBNDCbCkmzez02UtIg66mrFpB3Xn9XW9jBFlbtFFFoW9bAJpJtsCVKclspumk3QSYJJragLUV+YYkfVeLHGa0tpRYjThii5FervmzZEV29dbRTTMSkSTNOtkHB6U+x/z6FDhw7jeinLZweu7+SFC+WfIUp/XynoNWvWeJ/5zGeeR87ekSNHDpME3UDd2e9m8h5QBIdJfcSr7st5JLWmCJAIIZJY7URW398dtq62qeDgJvY6j/Jf/s7vIDj26bVr11o+/PBDTXxdXV36aPAH5kgSdAQ9jZojamIfNURYTdGU4ibBtCoOIigWV+pqiQaxYsWKlvXr13sYaQAZCUiT8VsF8N/qypGADcdIgumbx+M1XlKKm7iSqDiI4Mfz49vqHBwmPYQzU11Wm6jZRk6eJCgjZQVD8vhibh131JyzYSE8kKEQoC838LtejnyduSdBU2dYxltvvrnk5+c++KB8wc1rS0eOHGnElANJvpSnMreI/fF6giZDJguO2xHOYW1+KGtgOoW8Ovt+izOhGaQnZJQk1JxD7fBxNQcPqON/UKS3yUfsCKrDFXVUvTZX94MLShDE9tK//ta3vOvXr3s31MAR0P6NwUHt4zAlOj+F0mnQx6EJtNEbv5EOKhHrasfNqjphAjsP/d8/rZ54fvU8m2KEs1pJpGtIM6E5ATI8ZpopHDQDhHcYz+f1OztlDoPsMJ5M1lwuSX3qhQsXvM2bNzdk3tTqoGKT3SfGvK2AUz7Cy91kz0mjASdUp7FaytcQUduyZFL3gp3+YyK4467MU6P0DnuOBFycIUGpSYRvQYb4N3CE3yHG5FmoyZeQWoAb8leeeiqR9A+8v52+YOG8j/BCTQBF3r0eETsSqrWF1eJ945vfvHP58mVt3Vz68ENt3XR1d3sbNmxYeNzV9VOxbHklqATLDt3Ezbr5+cOKUGAW/7FSaF0ou3tq585oE6cKIftMnWmL8Ma9xupqyz0X04JsHp623zHNHn9J+odXrly5auvWrR6G99xzZCSSYH6giOiYSac5Pjc3N/zuu+96A/39FV9vBy1g3oaMvP0L9Tn/owjny2/2J5jMvDvrvzVO/+OKFSuWWDda8lkWThadgEiChE2EqDbBpDuuTKLRq1evln+GEjzpkdeAUrhc1HOXYI30I/miWTWliKMTTpLWTaWqJ5At9yEmCUa90ccUGR72rI7Gly5d8r90iR/PPPdTnkH3CNcsfC7v0qernsRPDiKET12SlX0EeL7Z758WTqHQZAgSRFea+2b8hbcQQNmnRp/6+RY1DqAqxR/IsNNVithNuoDoDTLxXbl+R44cGVOHbwjBQRHCPYNqDosAQZT71Gu3UAkSUYgQXWn+iXr4hXqrLorUlKEpJ4wj18/k5R0zyct/pEa3GrfU+J/eQt5eiVfTMRKs1pLbdiqnQISvqMMreT9ffj+lFZFO7OYv2nalyNWD22PJdp6O/Y1W8vILahzPW7UGSTAc9EWDLwOS3i7OFv+Gryg7Lxd5LEvzqUotamIkWJRd2f7V7/3eXyF3D51XkL8nwQv4CD/66CNvZGRE5/ApcoHbY7cillznZxriO0a6c5QE1QU8qm42BBpgfpadvUgfCCjKPpqXvUwFrTR/nYMivdUhO6+MNvpZWMArRYjz2HGFJJgdEWLFHVNkCEmPbhXDhgClKPsYfRyL6jPlqGbFSOoD9/rwLV3AlNUhXVgE0olFqpQagG52gWAFSNDepU0W+qLtpkcSjIcM7U4VHn0cwUirYYJBb6XPtPyS47H8XVZZoL/BxUwCDRTsIIiUaS4h+cZIcIu30GDgJUldAQn61F95keddTRL0kyFvighwuStJkOqsURaYyKIY9/aR0mRALei4lw+r8aJFgOfNc1zkSYJE3IqmCNB5bwWJRBs3zgGzL4gQ33HetSTBQsF131gegDSP3/ra16Zee/VVHbG1SxiRxtLX2+tt3bbN27NnDwjloCKSF1wkQ15pkmAh4c/ZK1ID0BSxf3Bw0Nv/wgK33bp1Sw8007U2DgJe5KkiSIKOII4C/DypT9tETWqTckmNMr32ljyPwbQSgiSYH2zRJzgjf1wWe6TY7cOSilCbbRSWkJ2dZzdXkIRtIj2wgULCJMiGCQnduIr4ZCQF9PLzp8FAhUpDAoIkSFB9ArvF/C0QdAcWITwhQ/uxwXnzWoLmMBEWCZNFWX2i6WuSOHToED5rbN26dRtRT3vmzJklJYKI2GJfZPjtdivg9a7kd1odWA7jT1Vk2O2rxUYbqqNMZSEJEnUg5WqOMhKISIME//Srv/mbZdK7fu0agj1et9ksyKq9PWKI45hL10qRHJKZUaYp20ce93JYn06QBIkISCoiHbLhgHNwbftIgiRIpAwEJrBZkNS/2s9LOguaBBAESbCJcTuDdJUsyDAoUht3JxT45tBxJaiZAXMEibruXZ6C5MGyuVjwF0J2iNCCDGXXNPm/RYLf5ekiSIJNjulidI0pw9QCY1OrE0Fk6C20ncLGV33qtQd4BxA0h7NHbvLnipKwbTXXHfMWIs3Dnmk7xfZqBEkwf3hkk/CkYHLwSvJ//57IBVSFIMMt6u/ezXQVgiTorpl6Ksa3Rfuol377619/gFw9tJpaqch3ZmbG6+7u1gnLX/jCF3TunnodbMdvIweuAGRIAiRIgg4j9ny9gYGBVjW8J1P8I+zW8H5I4IIgSIJEKkDqiJCPDMnXk5y9GEkJJI5gRLd/s6AKW6GWeIWIPILR4aKtasuX6+RltJzCDnB4jOeEIGM2RRGY+LYoQpAhIrY4WgSI1JZ9jNgSVIJNivsFzhEM2izISlf5gbcQtaUCJEiCzYzJCxcKT4q+zYKQz3eMu6QRJMEmBTYEUofe5z73OR2lRbRWAPP01syMNzIy4q0ZHNyhXjtuCONYgcjwKO8CgiTY3MAG4aPPPfdc+Qn4yQBpDW+wwYxxnjKCIAkWDpIyggCBTX52dxUW/BMESbCwkHQRQDqp2J1P7rOpAkGQBJsF/rZPSUFy85ASYycvS4eVuNtaEUQhrDaeAvdhSuCQrzcjTUwxZFc0kKMhwEnzOgYvCIJKsHhEaO2H8W+U8uuyfow65aPstEIQJMGiE6E/ebnXkN84zw5BkASbiQxL6nCAZ4IgaoM+QYIgSIJE/JDAhB/SaIAtpgiCJFhUHPZMw1QQnURnZU8MX4cVbAh0jKeMILLDMuaOJYNDhw4dMIQ47PsROqwc8RZqhks8UwRBEiw6GR40ZDhljsfZYYUg8oP/L8AAE/l00F91hwcAAAAASUVORK5CYII="
          transform="translate(2648.00, 592.00) rotate(0.00, 160.50, 138.50)"
        />
        <image
          width={192}
          height={384}
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref="data:image/png;base64,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"
          transform="translate(440.00, 496.00) rotate(0.00, 96.00, 192.00)"
        />
        <image
          width={160}
          height={352}
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref="data:image/png;base64,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"
          transform="translate(2072.00, 432.00) rotate(0.00, 80.00, 176.00)"
        />
        <image
          width={160}
          height={256}
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref="data:image/png;base64,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"
          transform="translate(1496.00, 656.00) rotate(0.00, 80.00, 128.00)"
        />
        <image
          width={176}
          height={72}
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref="data:image/png;base64,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"
          transform="translate(192.00, 240.00) rotate(0.00, 88.00, 36.00)"
        />
        <image
          width={88}
          height={88}
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref="data:image/png;base64,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"
          transform="translate(16.00, 1032.00) rotate(0.00, 44.00, 44.00)"
        />
        <g
          id="3ce8b12b-a87c-4bdb-0523-0215b251700a_svg"
          className="tl-centered-g"
          transform="translate(535.22, 856.00) rotate(0.00, 0.50, 92.00)"
        >
          <defs>
            <mask id="3ce8b12b-a87c-4bdb-0523-0215b251700a_clip">
              <rect x={-100} y={-100} width={201} height={384} fill="white" />
              <rect
                x={0}
                y={92}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,184L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M -7.999999999999999,13.85640646055102 L 0,0 7.99,13.85640646055102"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="21711436-cb60-4dcf-1c2f-02ee91295d06_svg"
          className="tl-centered-g"
          transform="translate(624.00, 752.00) rotate(0.00, 16.00, 0.50)"
        >
          <defs>
            <mask id="21711436-cb60-4dcf-1c2f-02ee91295d06_clip">
              <rect x={-100} y={-100} width={232} height={201} fill="white" />
              <rect
                x={16}
                y={0}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L32,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="eaa1f33d-cdf6-4c05-0bf0-fc5b3adb0ab0_svg"
          className="tl-centered-g"
          transform="translate(656.00, 752.00) rotate(0.00, 0.50, 144.00)"
        >
          <defs>
            <mask id="eaa1f33d-cdf6-4c05-0bf0-fc5b3adb0ab0_clip">
              <rect x={-100} y={-100} width={201} height={488} fill="white" />
              <rect
                x={0}
                y={144}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L0,288"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="d9a24c6f-bb3c-4f85-20f6-eb3017403f25_svg"
          className="tl-centered-g"
          transform="translate(1072.00, 520.00) rotate(0.00, 0.50, 24.00)"
        >
          <defs>
            <mask id="d9a24c6f-bb3c-4f85-20f6-eb3017403f25_clip">
              <rect x={-100} y={-100} width={201} height={248} fill="white" />
              <rect
                x={0}
                y={24}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,48L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="8158999e-2aaa-49ea-2b09-989e4eeb3c32_svg"
          className="tl-centered-g"
          transform="translate(1072.00, 520.00) rotate(0.00, 68.00, 0.50)"
        >
          <defs>
            <mask id="8158999e-2aaa-49ea-2b09-989e4eeb3c32_clip">
              <rect x={-100} y={-100} width={336} height={201} fill="white" />
              <rect
                x={68}
                y={0.08}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L136,0.17"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="62fdc926-d082-416d-3cb2-8cd929edc4f5_svg"
          className="tl-centered-g"
          transform="translate(1528.00, 520.00) rotate(0.00, 0.50, 84.00)"
        >
          <defs>
            <mask id="62fdc926-d082-416d-3cb2-8cd929edc4f5_clip">
              <rect x={-100} y={-100} width={201} height={368} fill="white" />
              <rect
                x={0}
                y={84}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L0,168"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 7.99,154.14359353944897 L 0,168 -7.999999999999999,154.14359353944897"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="79ac108c-df5c-46b7-2b67-0266b4a9b3a2_svg"
          className="tl-centered-g"
          transform="translate(2200.00, 672.00) rotate(0.00, 36.00, 0.50)"
        >
          <defs>
            <mask id="79ac108c-df5c-46b7-2b67-0266b4a9b3a2_clip">
              <rect x={-100} y={-100} width={272} height={201} fill="white" />
              <rect
                x={36}
                y={0}
                width={0}
                height={0}
                rx={2.25}
                ry={2.25}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L72,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="00a6fe7c-c22e-437f-2366-e23a506a7c9b_svg"
          className="tl-centered-g"
          transform="translate(2279.72, 304.00) rotate(0.00, 0.50, 144.00)"
        >
          <defs>
            <mask id="00a6fe7c-c22e-437f-2366-e23a506a7c9b_clip">
              <rect x={-100} y={-100} width={201} height={488} fill="white" />
              <rect
                x={0.14}
                y={144}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0.28,288L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="27a395b0-7669-4eaf-1ae7-074ba56ff3c8_svg"
          className="tl-centered-g"
          transform="translate(2200.31, 592.00) rotate(0.00, 39.84, 0.50)"
        >
          <defs>
            <mask id="27a395b0-7669-4eaf-1ae7-074ba56ff3c8_clip">
              <rect
                x={-100}
                y={-100}
                width={279.69}
                height={201}
                fill="white"
              />
              <rect
                x={39.84}
                y={0}
                width={0}
                height={0}
                rx={2.49}
                ry={2.49}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M79.69,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 13.85,7.999999999999999 L 0,0 13.85,-7.999999999999999"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="851ad789-72ef-4cbd-2c7e-00dee843498b_svg"
          className="tl-centered-g"
          transform="translate(2088.00, 576.00) rotate(0.00, 0.50, 28.00)"
        >
          <defs>
            <mask id="851ad789-72ef-4cbd-2c7e-00dee843498b_clip">
              <rect x={-100} y={-100} width={201} height={256} fill="white" />
              <rect
                x={0}
                y={28}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,56L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M -7.999999999999999,13.85640646055102 L 0,0 7.99,13.85640646055102"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="364b3288-209e-4d6b-2abf-8df549aaa8a0_svg"
          className="tl-centered-g"
          transform="translate(2552.00, 631.88) rotate(0.00, 32.00, 0.50)"
        >
          <defs>
            <mask id="364b3288-209e-4d6b-2abf-8df549aaa8a0_clip">
              <rect x={-100} y={-100} width={264} height={201} fill="white" />
              <rect
                x={32}
                y={0.06}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L64,0.12"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 50.15,-7.905966653981424 L 64,0.12 50.12,8.094005221092733"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="6357b201-c559-482d-14ce-f9fa01fd375c_svg"
          className="tl-centered-g"
          transform="translate(3064.00, 688.00) rotate(0.00, 0.50, 176.00)"
        >
          <defs>
            <mask id="6357b201-c559-482d-14ce-f9fa01fd375c_clip">
              <rect x={-100} y={-100} width={201} height={552} fill="white" />
              <rect
                x={0}
                y={176}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,352L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="184aff5c-4082-4cc7-1c4d-48a8aa11b781_svg"
          className="tl-centered-g"
          transform="translate(2969.00, 687.74) rotate(0.00, 47.50, 0.50)"
        >
          <defs>
            <mask id="184aff5c-4082-4cc7-1c4d-48a8aa11b781_clip">
              <rect x={-100} y={-100} width={295} height={201} fill="white" />
              <rect
                x={47.5}
                y={0.13}
                width={0}
                height={0}
                rx={2.96}
                ry={2.96}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M95,0.26L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="55d229f1-9741-4753-3c74-e39234a46625_svg"
          className="tl-centered-g"
          transform="translate(1600.00, 632.00) rotate(0.00, 0.50, 8.00)"
        >
          <defs>
            <mask id="55d229f1-9741-4753-3c74-e39234a46625_clip">
              <rect x={-100} y={-100} width={201} height={216} fill="white" />
              <rect
                x={0}
                y={8}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,16L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <text
          fontSize="43.411226369612976px"
          fontFamily="Crimson Pro"
          fontWeight="normal"
          line-height="43.411226369612976px"
          letterSpacing="-0.03em"
          text-align="left"
          dominantBaseline="mathematical"
          alignmentBaseline="mathematical"
          textAnchor="start"
          fill="#b7bdc3"
          transform="translate(664.00, 688.00) rotate(0.00, 100.50, 26.50)"
        >
          <tspan y="21.705613184806488px" x={4}>
            {"TOSTADOR\n"}
          </tspan>
        </text>
        <text
          fontSize="48.858447902995px"
          fontFamily="Crimson Pro"
          fontWeight="normal"
          line-height="48.858447902995px"
          letterSpacing="-0.03em"
          text-align="left"
          dominantBaseline="mathematical"
          alignmentBaseline="mathematical"
          textAnchor="start"
          fill="#b7bdc3"
          transform="translate(1112.00, 656.00) rotate(0.00, 104.50, 29.50)"
        >
          <tspan y="24.4292239514975px" x={4}>
            {"CICLONES\n"}
          </tspan>
        </text>
        <text
          fontSize="46.53897491837147px"
          fontFamily="Crimson Pro"
          fontWeight="normal"
          line-height="46.53897491837147px"
          letterSpacing="-0.03em"
          text-align="left"
          dominantBaseline="mathematical"
          alignmentBaseline="mathematical"
          textAnchor="start"
          fill="#b7bdc3"
          transform="translate(1649.50, 736.50) rotate(0.00, 42.00, 28.50)"
        >
          <tspan y="23.269487459185736px" x={4}>
            {"CPC\n"}
          </tspan>
        </text>
        <text
          fontSize="46.538974918371665px"
          fontFamily="Crimson Pro"
          fontWeight="normal"
          line-height="46.538974918371665px"
          letterSpacing="-0.03em"
          text-align="left"
          dominantBaseline="mathematical"
          alignmentBaseline="mathematical"
          textAnchor="start"
          fill="#b7bdc3"
          transform="translate(2035.50, 704.50) rotate(0.00, 29.00, 28.50)"
        >
          <tspan y="23.269487459185832px" x={4}>
            {"TE\n"}
          </tspan>
        </text>
        <text
          fontSize="44.984465160605374px"
          fontFamily="Crimson Pro"
          fontWeight="normal"
          line-height="44.984465160605374px"
          letterSpacing="-0.03em"
          text-align="left"
          dominantBaseline="mathematical"
          alignmentBaseline="mathematical"
          textAnchor="start"
          fill="#b7bdc3"
          transform="translate(2842.50, 864.00) rotate(0.00, 51.00, 27.50)"
        >
          <tspan y="22.492232580302687px" x={4}>
            {"HESP\n"}
          </tspan>
        </text>
        <g
          id="75f41b31-a35b-4afe-3128-5f51cfe1276c_svg"
          className="tl-centered-g"
          transform="translate(2272.00, 672.00) rotate(0.00, 0.50, 64.00)"
        >
          <defs>
            <mask id="75f41b31-a35b-4afe-3128-5f51cfe1276c_clip">
              <rect x={-100} y={-100} width={201} height={328} fill="white" />
              <rect
                x={0}
                y={64}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L0,128"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="0c56483e-857d-4098-3a81-79fdf96baf84_svg"
          className="tl-centered-g"
          transform="translate(2272.00, 1072.00) rotate(0.00, 0.50, 80.00)"
        >
          <defs>
            <mask id="0c56483e-857d-4098-3a81-79fdf96baf84_clip">
              <rect x={-100} y={-100} width={201} height={360} fill="white" />
              <rect
                x={0.03}
                y={80}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L0.05,160"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="button-infiltracion"
          onClick={() => {
            showModal(18);
          }}
          text-align="center"
          textAnchor="middle"
          transform="translate(3128.00, 1008.00) rotate(0.00, 112.00, 32.00)"
        >
          <g
            id="df0bdec9-a622-4d68-2ac5-7734f308e2ec_svg"
            className="tl-centered-g"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={221.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={221.88}
                y1={2.11}
                x2={221.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={221.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
          <text
            fontSize="28px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="28px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            transform="translate(52.5, 13)"
            fill="#b7bdc3"
            transform-origin="center center"
          >
            <tspan y="14px" x={63.5}>
              {"Infiltraci\xF3n\n"}
            </tspan>
          </text>
        </g>
        <g
          id="button-PLG-ETP"
          onClick={() => {
            showModal(19);
          }}
          text-align="center"
          textAnchor="middle"
          transform="translate(3128.00, 1104.00) rotate(0.00, 112.00, 32.00)"
        >
          <g
            id="c65cec45-00a2-4b99-0967-a1277756f214_svg"
            className="tl-centered-g"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={221.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={221.88}
                y1={2.11}
                x2={221.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={221.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
          <text
            line-height="28px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            transform="translate(60, 13)"
            fill="#b7bdc3"
            transform-origin="center center"
          >
            <tspan y="14px" x={56}>
              {"PLG/ETP\n"}
            </tspan>
          </text>
        </g>
        <g
          id="button-pas"
          onClick={() => {
            showModal(20);
          }}
          text-align="center"
          textAnchor="middle"
          transform="translate(3128.00, 1200.00) rotate(0.00, 112.00, 32.00)"
        >
          <g
            id="cf4d8bcf-9aea-44b3-0e43-40f162874b4d_svg"
            className="tl-centered-g"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={221.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={221.88}
                y1={2.11}
                x2={221.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={221.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
          <text
            fontSize="28px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="28px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            transform="translate(87.5, 13)"
            fill="#b7bdc3"
            transform-origin="center center"
          >
            <tspan y="14px" x={28.5}>
              {"PAS\n"}
            </tspan>
          </text>
        </g>
        <g
          id="26e158d8-1894-48d1-2a58-2925773fdac4_svg"
          className="tl-centered-g"
          transform="translate(2376.00, 1040.00) rotate(0.00, 88.00, 0.50)"
        >
          <defs>
            <mask id="26e158d8-1894-48d1-2a58-2925773fdac4_clip">
              <rect x={-100} y={-100} width={376} height={201} fill="white" />
              <rect
                x={88}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M176,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 13.85,7.999999999999999 L 0,0 13.85,-7.999999999999999"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="1b433191-88dd-4404-2ef2-f6f69a57de5b_svg"
          className="tl-centered-g"
          transform="translate(1400.00, 1224.00) rotate(0.00, 48.00, 0.50)"
        >
          <defs>
            <mask id="1b433191-88dd-4404-2ef2-f6f69a57de5b_clip">
              <rect x={-100} y={-100} width={296} height={201} fill="white" />
              <rect
                x={48}
                y={0}
                width={0}
                height={0}
                rx={3}
                ry={3}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L96,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 82.14,-7.999999999999999 L 96,0 82.14,7.999999999999999"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="cb7ac1c5-1106-4bba-30bd-bf54815b728a_svg"
          className="tl-centered-g"
          transform="translate(536.00, 432.00) rotate(0.00, 0.50, 28.00)"
        >
          <defs>
            <mask id="cb7ac1c5-1106-4bba-30bd-bf54815b728a_clip">
              <rect x={-100} y={-100} width={201} height={256} fill="white" />
              <rect
                x={0}
                y={28}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L0,56"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 7.99,42.14359353944898 L 0,56 -7.999999999999999,42.14359353944898"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="27c1fc64-22a1-4c03-2d43-932503db65b7_svg"
          className="tl-centered-g"
          transform="translate(376.00, 646.84) rotate(0.00, 24.00, 0.50)"
        >
          <defs>
            <mask id="27c1fc64-22a1-4c03-2d43-932503db65b7_clip">
              <rect x={-100} y={-100} width={248} height={201} fill="white" />
              <rect
                x={24}
                y={0.08}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0.17L48,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 34.11,-7.950875361759202 L 48,0 34.17,8.049024291962587"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="78a8d3fc-bd54-4169-26a4-3cfa1e7ec559_svg"
          className="tl-centered-g"
          transform="translate(376.00, 432.00) rotate(0.00, 80.00, 0.50)"
        >
          <defs>
            <mask id="78a8d3fc-bd54-4169-26a4-3cfa1e7ec559_clip">
              <rect x={-100} y={-100} width={360} height={201} fill="white" />
              <rect
                x={80}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M160,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="256702ea-dce6-44db-1c60-20d6c630dd41_svg"
          className="tl-centered-g"
          transform="translate(280.00, 312.00) rotate(0.00, 0.50, 44.00)"
        >
          <defs>
            <mask id="256702ea-dce6-44db-1c60-20d6c630dd41_clip">
              <rect x={-100} y={-100} width={201} height={288} fill="white" />
              <rect
                x={0}
                y={44}
                width={0}
                height={0}
                rx={2.75}
                ry={2.75}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,88L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="8e3c2bd4-d8c3-4ca0-0777-4ccc5c762c98_svg"
          className="tl-centered-g"
          transform="translate(104.00, 1040.00) rotate(0.00, 40.00, 0.50)"
        >
          <defs>
            <mask id="8e3c2bd4-d8c3-4ca0-0777-4ccc5c762c98_clip">
              <rect x={-100} y={-100} width={280} height={201} fill="white" />
              <rect
                x={40}
                y={0}
                width={0}
                height={0}
                rx={2.5}
                ry={2.5}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M80,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="006ef1b3-010c-4fc5-0711-0915813c3889_svg"
          className="tl-centered-g"
          transform="translate(1073.15, 792.00) rotate(0.00, 0.50, 28.00)"
        >
          <defs>
            <mask id="006ef1b3-010c-4fc5-0711-0915813c3889_clip">
              <rect x={-100} y={-100} width={201} height={256} fill="white" />
              <rect
                x={0.22}
                y={28}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0.45,56L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="cafd4bb0-b0bc-4275-2837-3c487bdb80e0_svg"
          className="tl-centered-g"
          transform="translate(1400.00, 520.00) rotate(0.00, 64.00, 0.50)"
        >
          <defs>
            <mask id="cafd4bb0-b0bc-4275-2837-3c487bdb80e0_clip">
              <rect x={-100} y={-100} width={328} height={201} fill="white" />
              <rect
                x={64}
                y={0.08}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0.16L128,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="9dbcee4d-bdce-4905-3036-51f7cdf99975_svg"
          className="tl-centered-g"
          transform="translate(1560.00, 304.00) rotate(0.00, 0.50, 192.00)"
        >
          <defs>
            <mask id="9dbcee4d-bdce-4905-3036-51f7cdf99975_clip">
              <rect x={-100} y={-100} width={201} height={584} fill="white" />
              <rect
                x={0}
                y={192}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L0,384"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 7.99,370.143593539449 L 0,384 -7.999999999999999,370.143593539449"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="a0bf5d8d-e038-49fc-24fb-50b605e7d90e_svg"
          className="tl-centered-g"
          transform="translate(1072.00, 1224.00) rotate(0.00, 68.00, 0.50)"
        >
          <defs>
            <mask id="a0bf5d8d-e038-49fc-24fb-50b605e7d90e_clip">
              <rect x={-100} y={-100} width={336} height={201} fill="white" />
              <rect
                x={68}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M136,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="14e77b36-f5db-4653-29e8-d18acb7aaab2_svg"
          className="tl-centered-g"
          transform="translate(2200.00, 631.82) rotate(0.00, 80.00, 0.50)"
        >
          <defs>
            <mask id="14e77b36-f5db-4653-29e8-d18acb7aaab2_clip">
              <rect x={-100} y={-100} width={360} height={201} fill="white" />
              <rect
                x={80}
                y={0.08}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M160,0L0,0.18"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="e2c6c1ce-e6fa-471c-39b6-8114a7630a64_svg"
          className="tl-centered-g"
          transform="translate(1976.00, 632.00) rotate(0.00, 56.00, 0.50)"
        >
          <defs>
            <mask id="e2c6c1ce-e6fa-471c-39b6-8114a7630a64_clip">
              <rect x={-100} y={-100} width={312} height={201} fill="white" />
              <rect
                x={56}
                y={0}
                width={0}
                height={0}
                rx={3.5}
                ry={3.5}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L112,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="eb84dd10-50e7-4518-15ff-a36df733d102_svg"
          className="tl-centered-g"
          transform="translate(1600.00, 632.00) rotate(0.00, 92.00, 0.50)"
        >
          <defs>
            <mask id="eb84dd10-50e7-4518-15ff-a36df733d102_clip">
              <rect x={-100} y={-100} width={384} height={201} fill="white" />
              <rect
                x={92}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M184,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="715e786c-9a8d-48f5-3228-c70f9d934f48_svg"
          className="tl-centered-g"
          transform="translate(2272.07, 864.00) rotate(0.00, 0.50, 64.00)"
        >
          <defs>
            <mask id="715e786c-9a8d-48f5-3228-c70f9d934f48_clip">
              <rect x={-100} y={-100} width={201} height={328} fill="white" />
              <rect
                x={0.33}
                y={64}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L0.65,128"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 8.57,114.10314771981508 L 0.65,128 -7.420260509397947,114.18439667222411"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="c96945e3-2ae3-42e1-16d3-4d00095f4c09_svg"
          className="tl-centered-g"
          transform="translate(2968.00, 656.00) rotate(0.00, 84.00, 0.50)"
        >
          <defs>
            <mask id="c96945e3-2ae3-42e1-16d3-4d00095f4c09_clip">
              <rect x={-100} y={-100} width={368} height={201} fill="white" />
              <rect
                x={84}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M168,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="bd3f3ec7-a227-41fd-05b3-670bb04029f0_svg"
          className="tl-centered-g"
          transform="translate(3328.00, 656.00) rotate(0.00, 56.00, 0.50)"
        >
          <defs>
            <mask id="bd3f3ec7-a227-41fd-05b3-670bb04029f0_clip">
              <rect x={-100} y={-100} width={312} height={201} fill="white" />
              <rect
                x={56}
                y={0}
                width={0}
                height={0}
                rx={3.5}
                ry={3.5}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L112,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 98.14,-7.999999999999999 L 112,0 98.14,7.999999999999999"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="b003a672-7921-4b57-044a-ee713d135992_svg"
          className="tl-centered-g"
          transform="translate(1072.00, 1072.00) rotate(0.00, 0.50, 76.00)"
        >
          <defs>
            <mask id="b003a672-7921-4b57-044a-ee713d135992_clip">
              <rect x={-100} y={-100} width={201} height={352} fill="white" />
              <rect
                x={0.1}
                y={76}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0.22,0L0,152"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="0f5bdc19-dd16-453c-065b-eeb1631d0890_svg"
          className="tl-centered-g"
          transform="translate(1072.78, 912.00) rotate(0.00, 0.97, 40.00)"
        >
          <defs>
            <mask id="0f5bdc19-dd16-453c-065b-eeb1631d0890_clip">
              <rect
                x={-100}
                y={-100}
                width={201.95}
                height={280}
                fill="white"
              />
              <rect
                x={0.97}
                y={40}
                width={0}
                height={0}
                rx={2.5}
                ry={2.5}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L1.95,80"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 9.60,65.95276593600659 L 1.95,80 -6.385274112678464,66.34265013018586"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="d0b7c395-1ac3-44e6-36bd-90d43b18fe78_svg"
          className="tl-centered-g"
          transform="translate(1576.00, 912.00) rotate(0.00, 0.50, 64.00)"
        >
          <defs>
            <mask id="d0b7c395-1ac3-44e6-36bd-90d43b18fe78_clip">
              <rect x={-100} y={-100} width={201} height={328} fill="white" />
              <rect
                x={0}
                y={64}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,128L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="a19ebfe9-0c7e-4ea3-2ca0-07461cfc0bd3_svg"
          className="tl-centered-g"
          transform="translate(1976.00, 1040.00) rotate(0.00, 88.00, 0.50)"
        >
          <defs>
            <mask id="a19ebfe9-0c7e-4ea3-2ca0-07461cfc0bd3_clip">
              <rect x={-100} y={-100} width={376} height={201} fill="white" />
              <rect
                x={88}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L176,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 162.14,-7.999999999999999 L 176,0 162.14,7.999999999999999"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          text-align="center"
          textAnchor="middle"
          transform="translate(2168.00, 1008.00) rotate(0.00, 96.00, 32.00)"
        >
          <g
            id="14c962cf-36fa-4e4f-165b-d18336403c21_svg"
            className="tl-centered-g"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
          <text
            fontSize="28px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="28px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            transform="translate(35, 13)"
            fill="#b7bdc3"
            transform-origin="center center"
          >
            <tspan y="14px" x={65}>
              {"ENF-POLV\n"}
            </tspan>
          </text>
        </g>
        <g
          id="0ba97dc9-1459-4edf-1e07-75d5cf1f3424_svg"
          className="tl-centered-g"
          transform="translate(376.00, 1040.00) rotate(0.00, 80.00, 0.50)"
        >
          <defs>
            <mask id="0ba97dc9-1459-4edf-1e07-75d5cf1f3424_clip">
              <rect x={-100} y={-100} width={360} height={201} fill="white" />
              <rect
                x={80}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L160,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          text-align="center"
          textAnchor="middle"
          transform="translate(968.00, 1008.00) rotate(0.00, 96.00, 32.00)"
        >
          <g
            id="fb640dd7-ce36-469f-0037-e3dcde15de09_svg"
            className="tl-centered-g"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
          <text
            fontSize="28px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="28px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            transform="translate(34, 13)"
            fill="#b7bdc3"
            transform-origin="center center"
          >
            <tspan y="14px" x={66}>
              {"ENF-CALC\n"}
            </tspan>
          </text>
        </g>
        <g
          id="2fd748e0-2229-413f-17cb-3916a7123efc_svg"
          className="tl-centered-g"
          transform="translate(2272.00, 1232.00) rotate(0.00, 40.00, 0.50)"
        >
          <defs>
            <mask id="2fd748e0-2229-413f-17cb-3916a7123efc_clip">
              <rect x={-100} y={-100} width={280} height={201} fill="white" />
              <rect
                x={40}
                y={0}
                width={0}
                height={0}
                rx={2.5}
                ry={2.5}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M80,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="5036abea-bcf0-4b67-2d10-a3baab76a21f_svg"
          className="tl-centered-g"
          transform="translate(2544.00, 1232.00) rotate(0.00, 80.00, 0.50)"
        >
          <defs>
            <mask id="5036abea-bcf0-4b67-2d10-a3baab76a21f_clip">
              <rect x={-100} y={-100} width={360} height={201} fill="white" />
              <rect
                x={80}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L160,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 146.14,-7.999999999999999 L 160,0 146.14,7.999999999999999"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="06565727-7fb4-4c37-0841-1327db1f91c7_svg"
          className="tl-centered-g"
          transform="translate(1576.00, 1040.00) rotate(0.00, 104.00, 0.50)"
        >
          <defs>
            <mask id="06565727-7fb4-4c37-0841-1327db1f91c7_clip">
              <rect x={-100} y={-100} width={408} height={201} fill="white" />
              <rect
                x={104}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M208,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="60253ef3-9090-405d-1fea-085ace3b31fb_svg"
          className="tl-centered-g"
          transform="translate(2744.00, 1040.00) rotate(0.00, 160.00, 0.50)"
        >
          <defs>
            <mask id="60253ef3-9090-405d-1fea-085ace3b31fb_clip">
              <rect x={-100} y={-100} width={520} height={201} fill="white" />
              <rect
                x={160}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L320,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="0a518817-65da-4f19-3193-1b21775bac4a_svg"
          className="tl-centered-g"
          transform="translate(656.00, 1040.00) rotate(0.00, 20.00, 0.50)"
        >
          <defs>
            <mask id="0a518817-65da-4f19-3193-1b21775bac4a_clip">
              <rect x={-100} y={-100} width={240} height={201} fill="white" />
              <rect
                x={20}
                y={0}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M40,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <g
          id="7c4e0ea8-a0f1-4e34-0091-cc7ae61cfcb5_svg"
          className="tl-centered-g"
          transform="translate(888.00, 616.00) rotate(0.00, 68.00, 0.50)"
        >
          <defs>
            <mask id="7c4e0ea8-a0f1-4e34-0091-cc7ae61cfcb5_clip">
              <rect x={-100} y={-100} width={336} height={201} fill="white" />
              <rect
                x={68}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L136,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
            <g>
              <path
                d="M 122.14,-7.999999999999999 L 136,0 122.14,7.999999999999999"
                fill="none"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="none"
              />
            </g>
          </g>
        </g>
        <g
          id="72e3eeec-9abb-4dd3-3ab8-09491ed02792_svg"
          className="tl-centered-g"
          transform="translate(640.00, 616.00) rotate(0.00, 28.00, 0.50)"
        >
          <defs>
            <mask id="72e3eeec-9abb-4dd3-3ab8-09491ed02792_clip">
              <rect x={-100} y={-100} width={256} height={201} fill="white" />
              <rect
                x={28}
                y={0}
                width={0}
                height={0}
                rx={2}
                ry={2}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M56,0L0,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>
        <text
          line-height="129.49569698665223px"
          letterSpacing="-0.03em"
          text-align="left"
          dominantBaseline="mathematical"
          alignmentBaseline="mathematical"
          textAnchor="start"
          fill="#b7bdc3"
          transform="translate(24.00, 16.00) rotate(0.00, 605.00, 69.50)"
        >
          <tspan id="title-diagram" y="64.74784849332612px" x={4}>
            {"DIAGRAMA TOSTACI\xD3N\n"}
          </tspan>
        </text>
        <g
          id="corriente-5-container"
          onClick={() => {
            showModal(5);
          }}
        >
          <g
            id="b62acd28-c83e-4857-2fab-8b4b0fb5623a_svg"
            className="tl-centered-g"
            transform="translate(696.00, 584.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
          <text
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(768.00, 616.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(5)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(753.50, 584.00) rotate(0.00, 40.00, 13.50)"
          >
            <tspan y="8.478445170312165px" x={44}>
              {"Corriente 5\n"}
            </tspan>
          </text>

          <g
            id="0cc30032-b3ad-47e8-1193-61285bf19129_svg"
            className="tl-centered-g"
            transform="translate(704.00, 616.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="0cc30032-b3ad-47e8-1193-61285bf19129_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
        </g>
        <g
          id="corriente-1-container"
          onClick={() => {
            showModal(1);
          }}
        >
          <g
            id="1bcc19dd-6844-40a6-2766-9cc4fec9be12_svg"
            className="tl-centered-g"
            transform="translate(184.00, 400.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(256.00, 432.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(1)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(242.50, 400.00) rotate(0.00, 39.00, 13.50)"
          >
            <tspan y="8.478445170312165px" x={43}>
              {"Corriente 1\n"}
            </tspan>
          </text>
          <g
            id="369dae9c-3851-4b00-2792-69ce3cff4dd2_svg"
            className="tl-centered-g"
            transform="translate(192.00, 432.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="369dae9c-3851-4b00-2792-69ce3cff4dd2_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-3-container"
          onClick={() => {
            showModal(3);
          }}
        >
          <text
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(256.00, 648.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(3)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(241.50, 616.00) rotate(0.00, 40.00, 13.50)"
          >
            <tspan y="8.478445170312165px" x={44}>
              {"Corriente 3\n"}
            </tspan>
          </text>
          <g
            id="5a8861ef-b0ec-4df8-3c52-d441f6e773f8_svg"
            className="tl-centered-g"
            transform="translate(192.00, 648.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="5a8861ef-b0ec-4df8-3c52-d441f6e773f8_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="1cf7d15b-8056-40b0-24ba-086b91cfcd44_svg"
            className="tl-centered-g"
            transform="translate(184.00, 616.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-2-container"
          onClick={() => {
            showModal(2);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(256.00, 1040.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(2)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(241.50, 1008.00) rotate(0.00, 40.00, 13.50)"
          >
            <tspan y="8.478445170312165px" x={44}>
              {"Corriente 2\n"}
            </tspan>
          </text>
          <g
            id="f2f14323-16f5-4aca-2ed8-46b82ff7db45_svg"
            className="tl-centered-g"
            transform="translate(192.00, 1040.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="f2f14323-16f5-4aca-2ed8-46b82ff7db45_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="adaf02e1-9064-4ca8-3300-9fb3a6971299_svg"
            className="tl-centered-g"
            transform="translate(184.00, 1008.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-4-container"
          onClick={() => {
            showModal(4);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(768.00, 1040.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(4)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(753.00, 1008.00) rotate(0.00, 40.50, 13.50)"
          >
            <tspan y="8.478445170312165px" x={44.5}>
              {"Corriente 4\n"}
            </tspan>
          </text>
          <g
            id="ba812819-c14d-494c-3812-45b481b61a50_svg"
            className="tl-centered-g"
            transform="translate(704.00, 1040.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="ba812819-c14d-494c-3812-45b481b61a50_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="dc58a687-d046-4eca-21e4-a5bfc282ba69_svg"
            className="tl-centered-g"
            transform="translate(696.00, 1008.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-7-container"
          onClick={() => {
            showModal(7);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1048.00, 880.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(7)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1033.50, 848.00) rotate(0.00, 40.00, 13.50)"
          >
            <tspan y="8.478445170312165px" x={44}>
              {"Corriente 7\n"}
            </tspan>
          </text>
          <g
            id="292eea2c-1586-4577-08f9-c94798dde616_svg"
            className="tl-centered-g"
            transform="translate(984.00, 880.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="292eea2c-1586-4577-08f9-c94798dde616_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="e287e58f-e91d-4ec5-1469-f83c55ca28bd_svg"
            className="tl-centered-g"
            transform="translate(976.00, 848.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-8-container"
          onClick={() => {
            showModal(8);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1280.00, 1224.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(8)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1264.00, 1192.00) rotate(0.00, 40.50, 13.50)"
          >
            <tspan y="8.478445170312165px" x={44.5}>
              {"Corriente 8\n"}
            </tspan>
          </text>
          <g
            id="b64770b4-ce5a-4287-047f-8fecc5bfc5a2_svg"
            className="tl-centered-g"
            transform="translate(1216.00, 1224.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="b64770b4-ce5a-4287-047f-8fecc5bfc5a2_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="66fc9fa6-a132-4367-2b36-19b5c9412c60_svg"
            className="tl-centered-g"
            transform="translate(1208.00, 1192.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-16-container"
          onClick={() => {
            showModal(16);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(2624.00, 1040.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(16)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(2606.50, 1008.00) rotate(0.00, 43.00, 13.50)"
          >
            <tspan y="8.478445170312165px" x={47}>
              {"Corriente 16\n"}
            </tspan>
          </text>
          <g
            id="06b85001-0153-4003-3df7-91eac4de8cb2_svg"
            className="tl-centered-g"
            transform="translate(2560.00, 1040.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="06b85001-0153-4003-3df7-91eac4de8cb2_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="6a244236-7fd2-445a-26f0-94fefa8fe821_svg"
            className="tl-centered-g"
            transform="translate(2552.00, 1008.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-11-container"
          onClick={() => {
            showModal(11);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1856.00, 1040.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(11)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1840.00, 1008.00) rotate(0.00, 41.50, 13.50)"
          >
            <tspan y="8.478445170312165px" x={45.5}>
              {"Corriente 11\n"}
            </tspan>
          </text>
          <g
            id="6c150335-fc25-4bf7-3f63-da5c721a9a0a_svg"
            className="tl-centered-g"
            transform="translate(1792.00, 1040.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="6c150335-fc25-4bf7-3f63-da5c721a9a0a_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="c9d5e707-3247-4291-0fca-6ff2ea2520ae_svg"
            className="tl-centered-g"
            transform="translate(1784.00, 1008.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-14-container"
          onClick={() => {
            showModal(14);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(2248.00, 832.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(14)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(2230.50, 800.00) rotate(0.00, 43.00, 13.50)"
          >
            <tspan y="8.478445170312165px" x={47}>
              {"Corriente 14\n"}
            </tspan>
          </text>
          <g
            id="33f1a5ff-4cf4-4a76-129a-a1382e362fa9_svg"
            className="tl-centered-g"
            transform="translate(2184.00, 832.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="33f1a5ff-4cf4-4a76-129a-a1382e362fa9_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="dea934dd-457a-41e6-012a-50131df7cf97_svg"
            className="tl-centered-g"
            transform="translate(2176.00, 800.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-17-container"
          onClick={() => {
            showModal(17);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(2424.00, 1232.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(17)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(2400.00, 1200.00) rotate(0.00, 42.50, 13.50)"
          >
            <tspan y="8.478445170312165px" x={46.5}>
              {"Corriente 17\n"}
            </tspan>
          </text>
          <g
            id="a383e4de-7c7d-4095-00e3-58b332afe16d_svg"
            className="tl-centered-g"
            transform="translate(2360.00, 1232.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="a383e4de-7c7d-4095-00e3-58b332afe16d_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="0bbcf910-2635-4a9f-0251-1edbb4eb53ea_svg"
            className="tl-centered-g"
            transform="translate(2352.00, 1200.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-15-container"
          onClick={() => {
            showModal(15);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(3208.00, 656.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(15)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(3191.00, 624.00) rotate(0.00, 42.50, 13.50)"
          >
            <tspan y="8.478445170312165px" x={46.5}>
              {"Corriente 15\n"}
            </tspan>
          </text>
          <g
            id="15caae84-6e6f-4b04-2018-90632787bf4f_svg"
            className="tl-centered-g"
            transform="translate(3144.00, 656.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="15caae84-6e6f-4b04-2018-90632787bf4f_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="3857aa00-726c-4249-344e-3dceca3476cd_svg"
            className="tl-centered-g"
            transform="translate(3136.00, 624.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-13-container"
          onClick={() => {
            showModal(13);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(2432.00, 632.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(13)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(2415.00, 600.00) rotate(0.00, 42.50, 13.50)"
          >
            <tspan y="8.478445170312165px" x={46.5}>
              {"Corriente 13\n"}
            </tspan>
          </text>
          <g
            id="a0e7678c-d66d-44ac-0cda-2275fc36e339_svg"
            className="tl-centered-g"
            transform="translate(2368.00, 632.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="a0e7678c-d66d-44ac-0cda-2275fc36e339_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
          <g
            id="2e717b21-1fd5-4d8c-1b0f-593717c6b34c_svg"
            className="tl-centered-g"
            transform="translate(2360.00, 600.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              id="corriente-13-container"
              onClick={() => {
                showModal(13);
              }}
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
        </g>

        <g
          id="corriente-6-container"
          onClick={() => {
            showModal(6);
          }}
        >
          <text
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1272.00, 520.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(6)}
            </tspan>
          </text>
          <text
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1257.50, 488.00) rotate(0.00, 40.00, 13.50)"
          >
            <tspan y="8.478445170312165px" x={44}>
              {"Corriente 6\n"}
            </tspan>
          </text>
        </g>

        <g
          id="324b7da7-8fae-4771-0df0-b5fb248f4953_svg"
          className="tl-centered-g"
          transform="translate(1216.00, 520.00) rotate(0.00, 88.00, 0.50)"
        >
          <defs>
            <mask id="324b7da7-8fae-4771-0df0-b5fb248f4953_clip">
              <rect x={-100} y={-100} width={376} height={201} fill="white" />
              <rect
                x={88}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L176,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>

        <g
          id="1c3ec539-7d5c-4040-3c0f-410f181ef273_svg"
          className="tl-centered-g"
          transform="translate(1208.00, 488.00) rotate(0.00, 96.00, 32.00)"
        >
          <g
            pointerEvents="none"
            stroke="#b7bdc3"
            strokeWidth={4.23}
            strokeLinecap="round"
          >
            <line
              x1={2.11}
              y1={2.11}
              x2={189.88}
              y2={2.11}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
            <line
              x1={189.88}
              y1={2.11}
              x2={189.88}
              y2={61.88}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
            <line
              x1={189.88}
              y1={61.88}
              x2={2.11}
              y2={61.88}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
            <line
              x1={2.11}
              y1={61.88}
              x2={2.11}
              y2={2.11}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
          </g>
        </g>

        <g
          id="corriente-12-container"
          onClick={() => {
            showModal(12);
          }}
        >
          <text
            fontSize="19.128312897435908px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(2240.00, 272.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(12)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(2223.00, 240.00) rotate(0.00, 42.50, 13.50)"
          >
            <tspan y="8.478445170312165px" x={46.5}>
              {"Corriente 12\n"}
            </tspan>
          </text>
          <g
            id="df631c44-a9d7-41fd-32d5-8907f9219adb_svg"
            className="tl-centered-g"
            transform="translate(2176.00, 240.00) rotate(0.00, 96.00, 32.00)"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={189.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={2.11}
                x2={189.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={189.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
          <g
            id="99893476-a7a2-4630-1a56-cb98001ac7b5_svg"
            className="tl-centered-g"
            transform="translate(2184.00, 272.00) rotate(0.00, 88.00, 0.50)"
          >
            <defs>
              <mask id="99893476-a7a2-4630-1a56-cb98001ac7b5_clip">
                <rect x={-100} y={-100} width={376} height={201} fill="white" />
                <rect
                  x={88}
                  y={0}
                  width={0}
                  height={0}
                  rx={4}
                  ry={4}
                  fill="black"
                  opacity={1}
                />
              </mask>
            </defs>
            <g pointerEvents="none" opacity={1} mask="">
              <path
                d="M0,0L176,0"
                fill="#b7bdc3"
                stroke="#b7bdc3"
                strokeWidth={4.23}
                strokeDasharray="none"
                strokeDashoffset="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                pointerEvents="stroke"
              />
            </g>
          </g>
        </g>

        <g
          id="668134a8-f96a-4e44-3f26-7668d8ac478b_svg"
          className="tl-centered-g"
          transform="translate(1792.00, 632.00) rotate(0.00, 88.00, 0.50)"
        >
          <defs>
            <mask id="668134a8-f96a-4e44-3f26-7668d8ac478b_clip">
              <rect x={-100} y={-100} width={376} height={201} fill="white" />
              <rect
                x={88}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L176,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>

        <g
          id="corriente-10-container"
          onClick={() => {
            showModal(10);
          }}
        >
          <text
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1848.00, 632.00) rotate(0.00, 23.50, 14.50)"
          >
            <tspan y="9.564156448717954px" x={27.5}>
              {getValueClass.getValueCorriente(10)}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1830.00, 600.00) rotate(0.00, 43.50, 13.50)"
          >
            <tspan y="8.478445170312165px" x={47.5}>
              {"Corriente 10\n"}
            </tspan>
          </text>
        </g>

        <g
          id="d3a5e94d-9275-404f-2b9b-06f07d7e71d3_svg"
          className="tl-centered-g"
          transform="translate(1784.00, 600.00) rotate(0.00, 96.00, 32.00)"
        >
          <g
            pointerEvents="none"
            stroke="#b7bdc3"
            strokeWidth={4.23}
            strokeLinecap="round"
          >
            <line
              x1={2.11}
              y1={2.11}
              x2={189.88}
              y2={2.11}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
            <line
              x1={189.88}
              y1={2.11}
              x2={189.88}
              y2={61.88}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
            <line
              x1={189.88}
              y1={61.88}
              x2={2.11}
              y2={61.88}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
            <line
              x1={2.11}
              y1={61.88}
              x2={2.11}
              y2={2.11}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
          </g>
        </g>

        <g
          id="4569f2aa-e336-4edb-0408-7bd4004db607_svg"
          className="tl-centered-g"
          transform="translate(1464.00, 240.00) rotate(0.00, 96.00, 32.00)"
        >
          <g
            pointerEvents="none"
            stroke="#b7bdc3"
            strokeWidth={4.23}
            strokeLinecap="round"
          >
            <line
              x1={2.11}
              y1={2.11}
              x2={189.88}
              y2={2.11}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
            <line
              x1={189.88}
              y1={2.11}
              x2={189.88}
              y2={61.88}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
            <line
              x1={189.88}
              y1={61.88}
              x2={2.11}
              y2={61.88}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
            <line
              x1={2.11}
              y1={61.88}
              x2={2.11}
              y2={2.11}
              strokeDasharray="none"
              strokeDashoffset="none"
            />
          </g>
        </g>

        <g
          id="3dafca20-ab71-4f78-1d8b-ca94cf7d0430_svg"
          className="tl-centered-g"
          transform="translate(1472.00, 272.00) rotate(0.00, 88.00, 0.50)"
        >
          <defs>
            <mask id="3dafca20-ab71-4f78-1d8b-ca94cf7d0430_clip">
              <rect x={-100} y={-100} width={376} height={201} fill="white" />
              <rect
                x={88}
                y={0}
                width={0}
                height={0}
                rx={4}
                ry={4}
                fill="black"
                opacity={1}
              />
            </mask>
          </defs>
          <g pointerEvents="none" opacity={1} mask="">
            <path
              d="M0,0L176,0"
              fill="#b7bdc3"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeDasharray="none"
              strokeDashoffset="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          </g>
        </g>

        <g
          id="corriente-9-container"
          onClick={() => {
            showModal(9);
          }}
        >
          <text
            line-height="19.128312897435908px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1514.50, 240.00) rotate(0.00, 45.00, 14.50)"
          >
            <tspan y="9.564156448717954px" x={49}>
              {"Corriente 9\n"}
            </tspan>
          </text>
          <text
            fontSize="16.95689034062433px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="16.95689034062433px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            fill="#b7bdc3"
            transform="translate(1536.00, 272.00) rotate(0.00, 25.50, 13.50)"
          >
            <tspan y="8.478445170312165px" x={29.5}>
              {/* Corriente 9 */}
              {getValueClass.getValueCorriente(9)}
            </tspan>
          </text>
        </g>

        <g
          id="button-modelo-usd"
          onClick={() => {
            showModal(21);
          }}
          text-align="center"
          textAnchor="middle"
          transform="translate(3128.00, 1296.00) rotate(0.00, 112.00, 32.00)"
        >
          <g
            id="a90c958f-7e88-4b03-142a-2d4af5edc09c_svg"
            className="tl-centered-g"
          >
            <g
              pointerEvents="none"
              stroke="#b7bdc3"
              strokeWidth={4.23}
              strokeLinecap="round"
            >
              <line
                x1={2.11}
                y1={2.11}
                x2={221.88}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={221.88}
                y1={2.11}
                x2={221.88}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={221.88}
                y1={61.88}
                x2={2.11}
                y2={61.88}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
              <line
                x1={2.11}
                y1={61.88}
                x2={2.11}
                y2={2.11}
                strokeDasharray="none"
                strokeDashoffset="none"
              />
            </g>
          </g>
          <text
            fontSize="28px"
            fontFamily="Crimson Pro"
            fontWeight="normal"
            line-height="28px"
            letterSpacing="-0.03em"
            text-align="center"
            dominantBaseline="mathematical"
            alignmentBaseline="mathematical"
            textAnchor="middle"
            transform="translate(41, 13)"
            fill="#b7bdc3"
            transform-origin="center center"
          >
            <tspan y="14px" x={75}>
              {"Modelo USD\n"}
            </tspan>
          </text>
        </g>
      </svg>
    </>
  );
}
